import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aurea-branding',
  templateUrl: './aurea-branding.component.html',
  styleUrls: ['./aurea-branding.component.scss']
})
export class AureaBrandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
